<template>
  <v-menu
    bottom
    :right="selectAll"
    :left="!selectAll"
    offset-x
    :close-on-content-click="
      activityMenu ? activity.company && activity.company.length >= 2 : false
    "
    nudge-width="250"
    :nudge-bottom="activityMenu ? '30' : '0'"
    max-height="300px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        icon
        small
        class="button"
        :disabled="
          activityMenu
            ? activity.company &&
              !!activity.company.find(
                item =>
                  item.type === 'web' ||
                  item.type === 'mobile' ||
                  activity.company.length >= 2
              )
            : disabledView
        "
      />
    </template>
    <v-text-field
      :placeholder="$tc('SearchCompanyOrUser')"
      clearable
      class="text-input-height"
      color="accent"
      v-model="searchUserAndCompany"
    />
    <AssignmentMenuListItem
      :activityMenu="activityMenu"
      :searchUserAndCompany="searchUserAndCompany"
      :isUser="true"
      :filteredAssignees="filteredUsers"
      @addIndividualUser="$emit('addIndividualUser', $event)"
      @addCompanyOrUser="$emit('addCompanyOrUser', $event)"
    />
    <AssignmentMenuListItem
      :activityMenu="activityMenu"
      :isUser="false"
      :searchUserAndCompany="searchUserAndCompany"
      :filteredAssignees="filteredCompanies"
      @addIndividualUser="$emit('addIndividualUser', $event)"
      @addCompanyOrUser="$emit('addCompanyOrUser', $event)"
    />
  </v-menu>
</template>

<script>
import { activitiesTasksDataMixin } from "../../../../../mixins/field/activitiesTasksDataMixin";
import AssignmentMenuListItem from "../_Molecules/AssignmentMenuListItem.vue";
import _ from "lodash";
import { mapActions } from "vuex";
export default {
  name: "AssignmentMenu",

  mixins: [activitiesTasksDataMixin],

  components: {
    AssignmentMenuListItem
  },

  props: {
    /**
     * the activity where the menu was activated.
     */
    activity: {
      type: Object
    },
    /**
     * if user opens the menu in the activity (not the tasks button).
     */
    activityMenu: {
      type: Boolean,
      default: false
    },
    /**
     * if user opens the assign to all button (upper left corner of assignment).
     */
    selectAll: {
      type: Boolean,
      default: false
    },
    /**
     * disables when in view mode
     */
    disabledView: {
      type: Boolean
    }
  },

  data() {
    return {
      searchUserAndCompany: "",
      usersByCompany: []
    };
  },
  watch: {
    "activity.company"(value) {
      if (value[0] && value[0].company_id) {
        this.getUsersFromCompany(value[0]);
      } else {
        this.usersByCompany = [];
        this.loadAllUsers();
      }
    }
  },

  computed: {
    /**
     * @returns - sorted companies, if user searches for company the list gets filtered
     */
    filteredCompanies() {
      let companies = _.cloneDeep(this.companies);
      let sorted = companies.sort((a, b) => a.name.localeCompare(b.name));
      return sorted.filter(item => {
        if (item.status) {
          if (this.searchUserAndCompany) {
            return item.name
              .toLowerCase()
              .includes(this.searchUserAndCompany.toLowerCase());
          }
          return item;
        }
      });
    },
    /**
     * @returns - sorted Users, if user searches for users the list gets filtered
     */
    filteredUsers() {
      let userCompany = _.cloneDeep(this.allUsers);
      if (this.usersByCompany && this.usersByCompany.length > 0) {
        userCompany = this.usersByCompany;
      }
      let activeUsers = userCompany.filter(item => {
        return item.status;
      });
      let sorted = activeUsers.sort((a, b) =>
        a.first_name.localeCompare(b.first_name)
      );
      return sorted.filter(item => {
        let userName = this.getUserName(item.id);
        if (this.searchUserAndCompany) {
          return userName
            .toLowerCase()
            .includes(this.searchUserAndCompany.toLowerCase());
        }
        return item;
      });
    }
  },
  methods: {
    ...mapActions(["fetchUsersByCompanyID"]),
    async getUsersFromCompany(company) {
      try {
        let users;
        users = await this.fetchUsersByCompanyID(company.id);
        this.usersByCompany = users.data.data;
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>

<style scoped>
.button {
  border-style: dotted;
  bottom: 4px;
  border-color: #666666;
  right: 5px;
}
.v-menu__content {
  background-color: white;
  padding: 5px;
}
.v-list-group {
  text-align: left;
}
.v-list-group >>> .v-list-item__subtitle {
  font: normal normal normal 14px/18px Roboto;
  letter-spacing: 0.11px;
  color: #666666;
  opacity: 1;
}
.v-input.v-text-field >>> .v-text-field__details {
  display: none !important;
}
.v-input.text-input-height {
  padding-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/WorkOrderForm/_Organisms/AssignmentMenu.vue